
function BellIcon({ width = 22, height = 22, color = "#353535" }) {
	return (
		<svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.625 7.62V7.25C16.625 4.14375 14.1062 1.625 11 1.625C7.89375 1.625 5.375 4.14375 5.375 7.25V7.62C5.375 9.39875 4.42875 11.0525 2.885 11.9375C2.08375 12.3975 1.625 12.93 1.625 13.5C1.625 15.2263 5.8225 16.625 11 16.625C16.1775 16.625 20.375 15.2263 20.375 13.5C20.375 12.93 19.9162 12.3975 19.115 11.9375C17.5712 11.0537 16.625 9.39875 16.625 7.62Z"
				stroke={color}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.8648 18.5C13.3823 19.6038 12.281 20.375 10.9998 20.375C9.71852 20.375 8.61852 19.6038 8.13477 18.5013"
				stroke={color}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default BellIcon;
